module.exports = __webpack_public_path__ + "img/njc610-mono-with-pu-womens.af71f4a8.jpg";